import Avatar from "../assets/icon/avatar.svg";
import Logo from "../assets/icon/logo.svg";
import Menu from "../assets/icon/menu.svg";
import ShoppingCartSimple from "../assets/icon/shoppingCartSimple.svg";
import Check from "../assets/icon/check.svg";
import Check2 from "../assets/icon/check-2.svg";
import dotPurple from "../assets/icon/ellipse _109.svg";
import next from "../assets/icon/expand_right.svg";
import down from "../assets/icon/expand_down.svg";
import search from "../assets/icon/search.svg";
import down_2 from "../assets/icon/vector_10.svg";
import vector_down from "../assets/icon/vector_down.svg";
import miniMapIcon from "../assets/icon/miniMapIcon.svg";
import pinMap from "../assets/icon/pinMap.svg";
import Expand_right_2 from "../assets/icon/expand_right.svg";
import star from "../assets/icon/star_fill.svg";
import chatAll from "../assets/icon/chat_alt_fill.svg";
import location from "../assets/icon/locate.svg";
import time from "../assets/icon/time.svg";
import car from "../assets/icon/carSimple.svg";
import bed from "../assets/icon/bed.svg";
import door from "../assets/icon/door.svg";
import pPrev from "../assets/icon/pPrev.svg";
import pNext from "../assets/icon/pNext.svg";
import logoBusiness from "../assets/icon/logo_cong_ty.svg";
import phone from "../assets/icon/phone.png";
import gps from "../assets/icon/gps_fixed.png";
import dashboard from "../assets/icon/darhboard.svg";
import Buildings from "../assets/icon/buildings.svg";
import Message from "../assets/icon/message.svg";
import Phone from "../assets/icon/phone.svg";
import Storefront from "../assets/icon/storefront.svg";
import User from "../assets/icon/user.svg";
import User_1 from "../assets/icon/user_1.svg";
import User_purple from "../assets/icon/user_box.svg";
import Location from "../assets/icon/location.svg";
import ArrowDownWhite from "../assets/icon/arrow-down-white.svg";
import SearchWhite from "../assets/icon/search-white.svg";
import Lock from "../assets/icon/lock.svg";
import eye from "../assets/icon/eye.svg";
import facebook from "../assets/icon/facebook.svg";
import google from "../assets/icon/google.svg";
import warning from "../assets/icon/warning.svg";
import arrowDown from "../assets/icon/arrow_drop_down.svg";
import box from "../assets/icon/box.svg";
import bag from "../assets/icon/bag_alt.svg";
import trash from "../assets/icon/trash.svg";
import VietnamFlat from "../assets/icon/vi.svg";
import EngFlat from "../assets/icon/en.svg";
import Money from "../assets/icon/money.svg";
import Camera from "../assets/icon/camera.svg";
import Ticket from "../assets/icon/ticket.svg";
import Wallet from "../assets/icon/wallet_alt.svg";
import Crown from "../assets/icon/crown.svg";
import Camera_purple from "../assets/icon/camera_purple.svg";
import Credit_card from "../assets/icon/credit_card.svg";
import Clock_purple from "../assets/icon/clockCounterClockwise.svg";
import Bell from "../assets/icon/bell.svg";
import Bell_1 from "../assets/icon/bell_1.svg";
import Union from "../assets/icon/union.svg";
import Headphones_purple from "../assets/icon/headphones_fill.svg";
import plus from "../assets/icon/plus.svg";
import success from "../assets/icon/success.png";
import checkWhite from "../assets/icon/checkWhite.svg";
import Calendar from "../assets/icon/calendar.svg";
import Calendar_1 from "../assets/icon/calendar_1.svg";
import onedot from "../assets/icon/onedot.svg";
import TicketHome from "../assets/icon/ticketHome.svg";
import CloseRing from "../assets/icon/close_ring.svg";
import Info from "../assets/icon/info.svg";
import Exclude from "../assets/icon/exclude.svg";
import Exclude2 from "../assets/icon/exclude2.svg";
import Exclude3 from "../assets/icon/exclude3.svg";
import Exclude4 from "../assets/icon/exclude4.svg";
import Setting from "../assets/icon/setting_line.svg";
import arrowPurple from "../assets/icon/arrowPurple.svg";
import TrashOrange from "../assets/icon/trashOrange.svg";
import SignOutPurple from "../assets/icon/sign_out_squre.svg";
import userCircle from "../assets/icon/userCircle.svg";
import signOut from "../assets/icon/sign_out.svg";
import home from "../assets/icon/home.svg";
import home_1 from "../assets/icon/home_1.svg";
import chevronLeft from "../assets/icon/chevron-left.svg";
import searchPurple from "../assets/icon/searchPurple.svg";
import pinMap_2 from "../assets/icon/pinMap_2.svg";
import chevronRight from "../assets/icon/chevron-right.svg";
import edit from "../assets/icon/edit.svg";
import DeskAlt from "../assets/icon/desk_alt.svg";
import Tumer from "../assets/icon/tumer.svg";
import x from "../assets/icon/x.svg";
import staff from "../assets/icon/staff.svg";
import branches from "../assets/icon/branches.svg";
import chevronRight_2 from "../assets/icon/chevronRight_2.svg";
import filter from "../assets/icon/filter.svg";
import menuWhite from "../assets/icon/menuWhite.svg";
import ShoppingCartSimpleWhite from "../assets/icon/shoppingCartSimpleWhite.svg";
import closeCircle from "../assets/icon/closeCircle.svg";
import Favorite from "../assets/icon/favorite_fill.svg";
import pPrev_purple from "../assets/icon/pPrev_purple.svg";
import orderCancel from "../assets/icon/order_cancel.svg";
import orderFinish from "../assets/icon/order_finish.svg";
import orderPending from "../assets/icon/order_pending.svg";
import backWhite from "../assets/icon/back_white.svg";
import checkGreen from "../assets/icon/check_green.svg";
import chevronUpWhite from "../assets/icon/chevron-up-white.svg";
import chevronDownWhite from "../assets/icon/chevron-down-white.svg";
import mapPinRed from "../assets/icon/mapPinRed.svg";
import heart from "../assets/icon/heart.svg";
import unHeart from "../assets/icon/unHeart.svg";
import unHeartWhite from "../assets/icon/unHeartWhite.svg";
import chevronRightBlack from "../assets/icon/chevronRightBlack.svg";
import distance from "../assets/icon/distance.svg";
import fire from "../assets/icon/fire.svg";
import shield from "../assets/icon/sheild.svg";
import editWhite from "../assets/icon/editWhite.svg";
import pinMapGreen from "../assets/icon/pinMapGreen.svg";
import pinMapRed from "../assets/icon/pinMapRed.svg";
import closeCircleWhite from "../assets/icon/closeCircleWhite.svg";
import sucessGreen from "../assets/icon/sucessGreen.svg";
import xCircleRed from "../assets/icon/xCircleRed.svg";
import loginReq from "../assets/icon/loginReq.svg";
import playCirclePurple from "../assets/icon/playCirclePurple.svg";
import playCircle from "../assets/icon/playCircle.svg";
import newsPurple from "../assets/icon/newsPurple.svg";
import languagePurple from "../assets/icon/languagePurple.svg";
import sendWhite from "../assets/icon/sendWhite.svg";
import cartCheckPurple from "../assets/icon/cartCheckPurple.svg";
import wifiBlack from "../assets/icon/wifiBlack.svg";
import carBlack from "../assets/icon/carBlack.svg";
import creditCardBlack from "../assets/icon/creditCardBlack.svg";
import watchMore from "../assets/icon/watch_more.svg";
import comment from "../assets/icon/comment_light.svg";
import comment_bold from "../assets/icon/comment_bold.svg";
import share from "../assets/icon/shareReels.svg";
import sendComment from "../assets/icon/send-comment.svg";
import addImg from "../assets/icon/add-img.svg";
import tickBlue from "../assets/icon/tickBlue.png";
import userNotSign from "../assets/icon/userNotSign.svg";
import arrowDownPurple from "../assets/icon/arrow_drop_down_purple.svg";
import shopingCartAddBlack from "../assets/icon/shopping-cart-add.svg";
import shopingCartAddOrange from "../assets/icon/shopping-cart-add-orange.svg";
import favoriteStroke from "../assets/icon/favorite-stroke.svg";
import rss from "../assets/icon/rss.svg";
import archive from "../assets/icon/archive.svg";
import addBtn from "../assets/icon/add-btn.svg";
import removeBtn from "../assets/icon/remove-btn.svg";
import alarmClock from "../assets/icon/alarm-clock.svg";
import list from "../assets/icon/list.svg";
import arrownLeftWhite from "../assets/icon/arrown-left-white.svg";
import arrownRightWhite from "../assets/icon/arrown-right-white.svg";
import cartPurpleBold from "../assets/icon/cartPurpleBold.svg";
import calendarPurpleBold from "../assets/icon/calendarPurpleBold.svg";
import cardDiscountOrange from "../assets/icon/cardDiscountOrange.svg";
import tumerGray from "../assets/icon/tumer-gray.svg";
import searchGray from "../assets/icon/searchGray.svg";
// acccount
import emailWhite from "../assets/icon/email-white.svg";
import phoneWhite from "../assets/icon/phone-white.svg";
import editWhiteAcc from "../assets/icon/edit-white.svg";
import boxAcc from "../assets/icon/box-acc.svg";
import arownAcc from "../assets/icon/arown-acc.svg";
import calendarAcc from "../assets/icon/calendar-acc.svg";
import heartAcc from "../assets/icon/heart-acc.svg";
import markerAcc from "../assets/icon/marker-acc.svg";
import book from "../assets/icon/book-alt.svg";
import cameraAcc from "../assets/icon/Camera-acc.svg";
import emailPurple from "../assets/icon/email-purple.svg";
import phonePurple from "../assets/icon/phone-purple.svg";
import supportChat from "../assets/icon/messageChat.svg";
import calendarWhite from "../assets/icon/calendarWhite.svg";
import cardDiscountWhite from "../assets/icon/cardDiscountWhite.svg";
import checkFlowOrange from "../assets/icon/checkFlowOrange.svg";
import arrowSmallUpWhite from "../assets/icon/arrowSmallUpWhite.svg";
import starLine from "../assets/icon/star.svg";
import settingPurple from "../assets/icon/setting-purple.svg";
import servicesPurpleBold from "../assets/icon/servicesPurpleBold.svg";
import mapMarkerOrg from "../assets/icon/mapMarkerOrg.svg";
import comment_bold_purple from "assets/icon/comment_bold_purple.svg";

// btn assistan home
import xWhite from "../assets/icon/x-white.svg";
import homeWhite from "../assets/icon/home-white.svg";
import chatWhite from "../assets/icon/chat-white.svg";
import checkFlowGreen from "../assets/icon/checkFlowGreen.svg";
import momo from "../assets/icon/momo.ico";
import payon from "../assets/icon/payon.jpg";
import settingsSliders from "../assets/icon/settingsSliders.svg";
import crossPurple from "../assets/icon/crossPurple.svg";
import minusPurple from "../assets/icon/minusPurple.svg";
import chatPurple from "../assets/icon/chatPurple.svg";
import friendsPurple from "../assets/icon/friendsPurple.png";
import plusPurple from "../assets/icon/plusPurple.svg";
import exclamationPurple from "../assets/icon/exclamationPurple.svg";
import settingsSlidersPurple from "../assets/icon/settingsSlidersPurple.svg";
import lineGray from "../assets/icon/lineGray.svg";
import filterBlack from "../assets/icon/filterBlack.svg";
import closeBlack from "../assets/icon/closeBlack.svg";
import locationCate from "../assets/icon/locationCate.png";
import noApply from "../assets/icon/no-apply.svg";
import directionRed from "../assets/icon/directionRed.svg";
import archiveRed from "../assets/icon/archiveRed.svg";
import pinMapRedGoogle from "../assets/icon/pinMapRedGoogle.png";
import listOrange from "../assets/icon/listOrange.svg";
import barberOrange from "../assets/icon/barberOrange.svg";
import lipstickOrange from "../assets/icon/lipstickOrange.svg";
import boxOrange from "../assets/icon/boxOrange.svg";
import mapMarker from "assets/icon/mapMarker.svg";
import bellWhite from "assets/icon/bellWhite.svg";
import cartWhiteBold from "assets/icon/cartWhiteBold.svg";
import cartLineBlack from "assets/icon/cartLineBlack.svg";
import settingLineBlack from "assets/icon/settingLineBlack.svg";
import calendarGreen from "assets/icon/calendarGreen.svg";
import communityPurple from "assets/icon/communityPurple.svg";
import rewardOrange from "assets/icon/rewardOrange.svg";
import ticketRed from "assets/icon/ticketRed.svg";
import cateClinic from "assets/icon/cateClinic.svg";
import cateNail from "assets/icon/cateNail.svg";
import cateSalon from "assets/icon/cateSalon.svg";
import cateSanpham from "assets/icon/cateSanpham.svg";
import cateSpa from "assets/icon/cateSpa.svg";
import flash from "assets/icon/flash.svg";
import eyeCrossPurple from "assets/icon/eyeCrossPurple.svg";
import clockGray from "assets/icon/clockGray.svg";
import shareWhite from "assets/icon/shareWhite.svg";
import heartBoldBlack from "assets/icon/heartBoldBlack.svg";
import heartBoldRed from "assets/icon/heartBoldRed.svg";
import commentBoldBlack from "assets/icon/commentBoldBlack.svg";
import eyeBoldBlack from "assets/icon/eyeBoldBlack.svg";
import shareBoldBlack from "assets/icon/shareBoldBlack.svg";
import chevronLeftWhite from "assets/icon/chevronLeftWhite.svg";
import clockAppGray from "assets/icon/clockAppGray.svg";
import scanQrBtn from "assets/icon/scanQrBtn.svg";
import phoneWhiteBold from "assets/icon/phoneWhiteBold.svg";
import trendGreen from "assets/icon/trendGreen.svg";
import downLoadWhite from "assets/icon/downLoadWhite.svg";
import thumbUpPurple from "assets/icon/thumbUpPurple.svg";
import thumbUp from "assets/icon/thumbUp.svg";
import chatSquare from "assets/icon/chatSquare.svg";
import createAtGray from "assets/icon/createAtGray.svg";
import postGray from "assets/icon/postGray.svg";
import userGray from "assets/icon/userGray.svg";
import startBold from "assets/icon/startBold.svg";
import coins from "assets/icon/coins.svg";
import paperWhite from "assets/icon/paperWhite.svg";
import scanQrBtnOrange from "assets/icon/scanQrBtnOrange.svg";
import sendBlack from "assets/icon/sendBlack.svg";
import imageBlack from "assets/icon/imageBlack.svg";
import refresh from "assets/icon/refresh.svg";
import smilePurple from "assets/icon/smile_purple.svg";
import imagePurple from "assets/icon/img_purple.svg";
import stateLlite from "assets/icon/statellite.png";
import street from "assets/icon/street.png";
import movie from "assets/icon/movie.png";
import expend from "assets/icons/expend.svg"
import homePurpleBold from "assets/icon/homePurpleBold.svg"
import imageWhite from "assets/icon/imageWhite.svg"
import thumbUpWhite from "assets/icon/thumbUpWhite.svg"
import eyeWhite from "assets/icon/eyeWhite.svg"
import shareWhiteArrow from "assets/icon/shareWhiteArown.svg"
import heartSolidWhite from "assets/icon/heartSolidWhite.svg"
import chatSupport from "assets/icon/chatSupport.png"
import tag from "assets/icon/tag.png"
import addFileWhite from "assets/icon/add-file-white.svg"
import planPaperWhite from "assets/icon/planPaperWhite.svg"
import copyWhite from "assets/icon/copyWhite.svg"
import creditCard from "assets/icon/credit-card-black.svg"
import zalo from "assets/icon/zalo-icon.png"
import viettelpay from "assets/icon/viettelpay.png";

const icon = {
  viettelpay,
  heartSolidWhite,
  eyeWhite,
  shareWhiteArrow,
  smilePurple,
  imagePurple,
  noApply,
  payon,
  momo,
  settingPurple,
  chatWhite,
  homeWhite,
  xWhite,
  phonePurple,
  emailPurple,
  cameraAcc,
  book,
  boxAcc,
  arownAcc,
  calendarAcc,
  heartAcc,
  editWhiteAcc,
  markerAcc,
  emailWhite,
  phoneWhite,
  searchGray,
  tumerGray,
  arrownLeftWhite,
  arrownRightWhite,
  list,
  Favorite,
  Tumer,
  DeskAlt,
  edit,
  SignOutPurple,
  TrashOrange,
  Exclude,
  Exclude2,
  Exclude3,
  Exclude4,
  Info,
  CloseRing,
  TicketHome,
  success,
  Avatar,
  Logo,
  Menu,
  ShoppingCartSimple,
  Check,
  Check2,
  dotPurple,
  next,
  Expand_right_2,
  down,
  search,
  down_2,
  miniMapIcon,
  pinMap,
  star,
  chatAll,
  location,
  car,
  bed,
  time,
  door,
  pPrev,
  pNext,
  logoBusiness,
  phone,
  gps,
  dashboard,
  Buildings,
  Message,
  Phone,
  Storefront,
  User,
  User_purple,
  Location,
  Lock,
  eye,
  facebook,
  google,
  warning,
  arrowDown,
  box,
  bag,
  trash,
  VietnamFlat,
  EngFlat,
  Money,
  Camera,
  Ticket,
  Wallet,
  Crown,
  Camera_purple,
  Credit_card,
  Clock_purple,
  Bell,
  Bell_1,
  Union,
  Headphones_purple,
  plus,
  ArrowDownWhite,
  SearchWhite,
  checkWhite,
  Calendar,
  Calendar_1,
  onedot,
  Setting,
  arrowPurple,
  userCircle,
  signOut,
  home,
  chevronLeft,
  chevronRight,
  searchPurple,
  pinMap_2,
  x,
  staff,
  branches,
  chevronRight_2,
  filter,
  menuWhite,
  ShoppingCartSimpleWhite,
  closeCircle,
  home_1,
  pPrev_purple,
  User_1,
  orderCancel,
  orderFinish,
  orderPending,
  backWhite,
  checkGreen,
  chevronDownWhite,
  vector_down,
  chevronUpWhite,
  mapPinRed,
  heart,
  unHeart,
  unHeartWhite,
  chevronRightBlack,
  distance,
  fire,
  shield,
  editWhite,
  pinMapGreen,
  closeCircleWhite,
  sucessGreen,
  xCircleRed,
  loginReq,
  playCirclePurple,
  playCircle,
  newsPurple,
  languagePurple,
  sendWhite,
  cartCheckPurple,
  wifiBlack,
  carBlack,
  creditCardBlack,
  watchMore,
  comment,
  share,
  sendComment,
  addImg,
  tickBlue,
  userNotSign,
  comment_bold,
  arrowDownPurple,
  shopingCartAddBlack,
  shopingCartAddOrange,
  favoriteStroke,
  rss,
  archive,
  addBtn,
  removeBtn,
  alarmClock,
  cartPurpleBold,
  calendarPurpleBold,
  cardDiscountOrange,
  supportChat,
  calendarWhite,
  cardDiscountWhite,
  checkFlowOrange,
  arrowSmallUpWhite,
  starLine,
  checkFlowGreen,
  settingsSliders,
  settingsSlidersPurple,
  servicesPurpleBold,
  mapMarkerOrg,
  crossPurple,
  minusPurple,
  chatPurple,
  friendsPurple,
  plusPurple,
  exclamationPurple,
  lineGray,
  filterBlack,
  closeBlack,
  locationCate,
  pinMapRed,
  directionRed,
  archiveRed,
  pinMapRedGoogle,
  listOrange,
  barberOrange,
  lipstickOrange,
  boxOrange,
  mapMarker,
  bellWhite,
  cartWhiteBold,
  cartLineBlack,
  settingLineBlack,
  calendarGreen,
  rewardOrange,
  ticketRed,
  communityPurple,
  cateClinic,
  cateSalon,
  cateSanpham,
  cateSpa,
  cateNail,
  flash,
  eyeCrossPurple,
  clockGray,
  shareWhite,
  heartBoldBlack,
  heartBoldRed,
  commentBoldBlack,
  eyeBoldBlack,
  shareBoldBlack,
  chevronLeftWhite,
  clockAppGray,
  scanQrBtn,
  phoneWhiteBold,
  trendGreen,
  downLoadWhite,
  thumbUp,
  thumbUpPurple,
  chatSquare,
  createAtGray,
  postGray,
  userGray,
  comment_bold_purple,
  startBold,
  coins,
  paperWhite,
  scanQrBtnOrange,
  sendBlack,
  imageBlack,
  refresh,
  stateLlite,
  street,
  movie,
  expend,
  homePurpleBold,
  imageWhite, thumbUpWhite, chatSupport, tag,
  addFileWhite, planPaperWhite,creditCard,
  copyWhite,
  zalo
};
export default icon;
